import { render } from "./Medicinal.vue?vue&type=template&id=9e116d52"
import script from "./Medicinal.vue?vue&type=script&lang=js"
export * from "./Medicinal.vue?vue&type=script&lang=js"
script.render = render

export default script